import { moment } from "@msuite/utils/date";
import { useQueryState } from "../libs/nuqs";

export function useTimelineWeeklyControls() {
	const [currentWeek, setCurrentWeek] = useQueryState("current-week", {
		defaultValue: moment().dbWeek(),
		clearOnDefault: false,
	});

	/** Function */
	function onBack() {
		setCurrentWeek(moment().getMomentByDbWeek(currentWeek).subtract(1, "week").dbWeek());
	}

	function onForward() {
		setCurrentWeek(moment().getMomentByDbWeek(currentWeek).add(1, "week").dbWeek());
	}

	return {
		currentWeek,
		setCurrentWeek,
		onBack,
		onForward,
	};
}
